<template>
  <div>
    <a href='#' @click.prevent='doLike'><font-awesome-icon icon="thumbs-up" />Like</a>
  </div>
</template>
<script>
export default {
  methods: {
    doLike() {
      this.$emit("like")
    }
  }
}
</script>
